import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import { Action } from '../shared/common.action';
import { GoAPI } from '../connector/shared/api.go.service';
import { MyAction } from './my.actions';

@Injectable()
export class MyEffects {

  @Effect() attach$ = this.actions$
    .pipe(ofType(MyAction.FIND))
    .mergeMap((action: Action) => this.api.my(action.payload.data).get().mergeMap(response => Observable.from([
      this.myAction.findSuccess(response)
    ])).catch((error: any) => Observable.of(this.myAction.findFail(error))));

  constructor(private api: GoAPI,
              private actions$: Actions,
              private myAction: MyAction) {
  }
}
